const config = {
  apiUrl: import.meta.env.VITE_API_URL ?? 'http://localhost:3000',
  kbUrl: import.meta.env.VITE_KB_URL ?? 'http://localhost:3004',
  kbEndpoint: import.meta.env.VITE_KB_ENDPOINT ?? '/graphql',
  surveyUrl: import.meta.env.VITE_PATIENT_SURVEY_URL,
  trustpilotUrl: 'https://fr.trustpilot.com/evaluate/aldebaran.care',
  demoLemcalUrl: 'https://app.lemcal.com/@nicolas-jacquelinet/20min',
  posthog: {
    host: import.meta.env.VITE_POSTHOG_HOST,
    key: import.meta.env.VITE_POSTHOG_KEY,
  },
  kbVersion: isNaN(Number(import.meta.env.VITE_KB_VERSION))
    ? undefined
    : Number(import.meta.env.VITE_KB_VERSION),
  appVersion: import.meta.env.VITE_VERSION ?? 'development',
  demoPracticeSlug:
    import.meta.env.VITE_DEMO_PRACTICE_SLUG ?? 'cabinet-aldebaran-demo',
  env: {
    production: Boolean(import.meta.env.PROD && !import.meta.env.VITE_STAGING),
    staging: Boolean(import.meta.env.VITE_STAGING),
    dev: Boolean(import.meta.env.DEV),
    demo: Boolean(import.meta.env.VITE_DEMO),
  },
  debug: {
    evaluate: Boolean(import.meta.env.VITE_DEBUG_EVALUATE),
    after: Boolean(import.meta.env.VITE_DEBUG_AFTER),
    panel: Boolean(import.meta.env.VITE_DEBUG_PANEL),
  },
  sentry_dsn: import.meta.env.VITE_PATIENT_SENTRY_DSN,
};

export default config;
